import BonusTransaction from '@/views/bonus/BonusTransaction'
import Coupon from '@/views/coupon/Coupon'
import ClientsList from '@/views/events/ClientsList'
import EventList from '@/views/events/EventsList'
import FeedBackEvent from '@/views/events/FeedBackEvent'
import ReservationPage from '@/views/events/ReservationPage'
import ReservationPageAdd from '@/views/events/ReservationPageAdd'
import ReservationPageEdit from '@/views/events/ReservationPageEdit'
import SingleEvent from '@/views/events/SingleEvent'
import PlaceList from '@/views/places/PlaceList'
import Vue from 'vue'
import VueRouter from 'vue-router'

// import Cert from '@/views/certs/Cert'
import Acquiring from '@/views/acquiring/Acquiring.vue'
import CertNew from '@/views/certs/CertNew'
import ClubPlayer from '@/views/club_player/ClubPlayer'
import ClubPlayerClients from '@/views/club_player/ClubPlayerClients'
import ClubPlayerStatistics from '@/views/club_player/ClubPlayerStatistics'
import EventPackage from '@/views/events/EventPackage'
import EventPackagesList from '@/views/events/EventPackagesList'
import EventServicesCatalog from '@/views/events/EventServicesCatalog'
import SingleOffer from '@/views/events/SingleOffer.vue'
import SingleOfferAll from '@/views/events/SingleOfferAll.vue'
import FeedBack from '@/views/feedback/FeedBack.vue'
import FeedBackOne from '@/views/feedback/FeedBackOne.vue'
import Promocodes from '@/views/promocodes/Promocodes.vue'
import PromocodesPage from '@/views/promocodes/PromocodesPage.vue'
import Sales from '@/views/sales/Sales.vue'
import TaxDeduction from '@/views/tax_deduction/TaxDeduction.vue'
import TaxDeductionPage from '@/views/tax_deduction/TaxDeductionPage.vue'

import Qrcode_lockers from '@/views/qrcode_lockers/Qrcode_lockers.vue'
import Reports from '@/views/report/Reports.vue'
import store from '../store'

Vue.use(VueRouter)

const DEFAULT_TITLE = 'KhimkiBC Group'

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: { requiresAuth: true, title: 'Главная', permissions: 'dashboard' },
  },
  {
    path: '/offer/:uuid',
    component: SingleOfferAll,
    name: 'Оффер',
    meta: {
      layout: 'blank',
      title: 'Оффер',
      requiresAuth: false,
    },
  },
  {
    path: '/cash-payment',
    name: 'Прием наличных',
    component: () => import('@/views/events/CashPayment.vue'),
    meta: {
      requiresAuth: true,
      title: 'Приём наличных',
      permissions: 'cash_payment',
    },
  },
  {
    path: '/events',
    name: 'Сборы',
    component: EventList,
    meta: {
      requiresAuth: true,
      title: 'Список мероприятий',
      permissions: 'events',
    },
  },
  {
    path: '/clients',
    name: 'Клиенты',
    component: ClientsList,
    meta: {
      requiresAuth: true, title: 'Список клиентов', permissions: 'clients',
    },
  },
  {
    path: '/bonustransactions',
    name: 'Бонусы',
    component: BonusTransaction,
    meta: {
      requiresAuth: true, title: 'Операции с бонусами', permissions: 'bonuspoints',
    },
  },
  {
    path: '/events/:id/new',
    name: 'Новое бронирование',
    component: ReservationPageAdd,
    meta: {
      requiresAuth: true, title: 'Новое бронирование', permissions: 'events',
    },
  },
  {
    path: '/events/:id',
    name: 'Страница мероприятия',
    component: SingleEvent,
    meta: {
      requiresAuth: true, title: 'Мероприятие', permissions: 'events',
    },
  },
  {
    path: '/events/:id/offer/:uuid',
    name: 'Страница оффера',
    component: SingleOffer,
    meta: {
      requiresAuth: true, title: 'Оффер', permissions: 'events',
    },
  },
  {
    path: '/events/:id/packages',
    name: 'Пакеты мероприятия',
    component: EventPackagesList,
    meta: {
      requiresAuth: true, title: 'Пакеты мероприятия', permissions: 'events',
    },
  },
  {
    path: '/events/:id/packages/:package_id',
    name: 'Пакет мероприятия',
    component: EventPackage,
    meta: {
      requiresAuth: true, title: 'Пакет мероприяти', permissions: 'events',
    },
  },
  {
    path: '/events/:id/services',
    name: 'Каталог услуг мероприятия',
    component: EventServicesCatalog,
    meta: {
      requiresAuth: true, title: 'Каталог услуг', permissions: 'events',
    },
  },
  {
    path: '/events/:id/:reservation_id',
    name: 'Страница бронирования',
    component: ReservationPage,
    meta: {
      requiresAuth: true, title: 'Бронирование', permissions: 'events',
    },
  },
  {
    path: '/events/:id/:reservation_id/edit',
    name: 'Редактировать бронирование',
    component: ReservationPageEdit,
    meta: {
      requiresAuth: true, title: 'Редактировать бронирование', permissions: 'events',
    },
  },
  {
    path: '/events/:id/feedback/:uuid',
    name: 'Обратная связь спортсменов',
    component: FeedBackEvent,
    meta: {
      requiresAuth: false,
      title: 'Обратная связь спортсменов',
      layout: 'short',
    },
  },
  {
    path: '/places',
    name: 'Места',
    component: PlaceList,
    meta: {
      requiresAuth: true, title: 'Места', permissions: 'events',
    },
  },
  {
    path: '/coupons',
    name: 'Купоны',
    component: Coupon,
    meta: {
      requiresAuth: true, title: 'Купоны', permissions: 'coupons',
    },
  },
  {
    path: '/certs',
    name: 'Сертификаты',
    component: CertNew,
    meta: {
      requiresAuth: true, title: 'Сертификаты', permissions: 'certs',
    },
  },
  {
    path: '/club_player',
    name: 'Клубный игрок',
    component: ClubPlayer,
    meta: {
      requiresAuth: true, title: 'Клубный игрок', permissions: 'club_player',
    },
  },
  {
    path: '/club_player/clients',
    name: 'Участники программы клубный игрок',
    component: ClubPlayerClients,
    meta: {
      requiresAuth: true, title: 'Участники программы клубный игрок', permissions: 'club_player',
    },
  },
  {
    path: '/club_player/statistics',
    name: 'Статистика клубный игрок',
    component: ClubPlayerStatistics,
    meta: {
      requiresAuth: true, title: 'Статистика клубный игрок', permissions: 'club_player',
    },
  },
  { // Promocodes
    path: '/promocodes',
    name: 'Промокоды',
    component: Promocodes,
    meta: {
      requiresAuth: true, title: 'Промокоды', permissions: 'promocodes',
    },
  },

  {
    path: '/tax_deduction/:id',
    name: 'Справка для налогового вычета',
    component: TaxDeductionPage,
    meta: {
      requiresAuth: true, title: 'Налоговый вычет', permissions: 'tax_deduction',
    },
  },

  { // Sales
    path: '/sales',
    name: 'Акции',
    component: Sales,
    meta: {
      requiresAuth: true, title: 'Акции', permissions: 'sales',
    },
  },

  {
    path: '/promocodes/:id',
    name: 'Отдельный промокод',
    component: PromocodesPage,
    meta: {
      requiresAuth: true, title: 'Промокоды', permissions: 'promocodes',
    },
  },
  { // TaxDeduction
    path: '/tax_deduction',
    name: 'Налоговый вычет',
    component: TaxDeduction,
    meta: {
      requiresAuth: true, title: 'Налоговый вычет', permissions: 'tax_deduction',
    },
  },
  { // Acquiring
    path: '/acquiring',
    name: 'Эквайринг',
    component: Acquiring,
    meta: {
      requiresAuth: true, title: 'Эквайринг', permissions: 'acquiring',
    },
  },

  { // Обратная связь
    path: '/feedback',
    name: 'Обратная связь',
    component: FeedBack,
    meta: {
      requiresAuth: true, title: 'Обратная связь', permissions: 'feedback',
    },
  },
  { //
    path: '/feedback/:uuid',
    name: 'Обратная связь клиента',
    component: FeedBackOne,
    meta: {
      requiresAuth: true, title: 'Обратная связь клиента', permissions: 'feedback',
    },
  },

  {
    path: '/benefits',
    redirect: '/benefits/requests',
  },
  {
    path: '/benefits/requests/:id',
    name: 'Обработка заявки льгот',
    component: () => import('@/views/benefits/BenefitRequestProcess.vue'),
    meta: {
      requiresAuth: true, title: 'Обработка заявки льгот', permissions: 'benefits',
    },
  },
  {
    path: '/benefits/user-benefits/:id',
    name: 'Обработка льготы пользователя',
    component: () => import('@/views/benefits/UserBenefitProcess.vue'),
    meta: {
      requiresAuth: true, title: 'Обработка льготы пользователя', permissions: 'benefits',
    },
  },
  {
    path: '/benefits/:section',
    name: 'Льготы',
    component: () => import('@/views/benefits/Benefits.vue'),
    meta: {
      requiresAuth: true, title: 'Льготы', permissions: 'benefits',
    },
    beforeEnter(to, from, next) {
      const valid = ['requests', 'user-benefits', 'logs', 'new-request']
      if (!valid.includes(to.params.section)) {
        next({ path: '/benefits/requests' })
        return
      }
      next()
    },
  },

  {
    path: '/coaches',
    redirect: '/coaches/list',
  },
  {
    path: '/coaches/:section',
    name: 'Тренеры',
    component: () => import('@/views/coaches/Coaches.vue'),
    meta: {
      requiresAuth: true, title: 'Тренеры', permissions: 'coaches',
    },
    beforeEnter(to, from, next) {
      const valid = ['list', 'settings', 'periods', 'topups']
      if (!valid.includes(to.params.section)) {
        next({ path: '/coaches/list' })
        return
      }
      next()
    },
  },

  {
    path: '/rating',
    redirect: '/rating/coaches',
  },
  {
    path: '/rating/:section',
    name: 'Рейтинг',
    component: () => import('@/views/rating/Rating.vue'),
    meta: {
      requiresAuth: true, title: 'Рейтинг', permissions: 'rating',
    },
    beforeEnter(to, from, next) {
      const valid = ['coaches', 'criteria']
      if (!valid.includes(to.params.section)) {
        next({ path: '/rating/coaches' })
        return
      }
      next()
    },
  },

  { // Qrcode_lockers
    path: '/qrcode_lockers',
    name: 'Шкафчики ВДНХ',
    component: Qrcode_lockers,
    meta: {
      requiresAuth: true, title: 'Шкафчики ВДНХ', permissions: 'qrcode_lockers',
    },
  },

  { // Reporst
    path: '/reports',
    name: 'Отчеты',
    component: Reports,
    meta: {
      requiresAuth: true, title: 'Отчеты', permissions: 'reports',
    },
  },

  {
    path: '/analytics',
    component: () => import('@/views/analytics/Index.vue'),
    meta: {
      requiresAuth: true, title: 'Аналитика', permissions: 'analytics',
    },
    children: [
      {
        path: '',
        redirect: { name: 'AnalyticsFunnel' },
      },
      {
        path: 'funnel',
        name: 'AnalyticsFunnel',
        component: () => import('@/views/analytics/Funnel.vue'),
        meta: {
          requiresAuth: true, title: 'Воронка', permissions: 'analytics',
        },
      },
      {
        path: 'sources',
        name: 'AnalyticsSources',
        component: () => import('@/views/analytics/Sources.vue'),
        meta: {
          requiresAuth: true, title: 'Источники', permissions: 'analytics',
        },
      },
      {
        path: 'customers',
        name: 'AnalyticsCustomers',
        component: () => import('@/views/analytics/ClientCard.vue'),
        meta: {
          requiresAuth: true, title: 'Клиенты аналитики', permissions: 'analytics',
        },
      },
      {
        path: 'customers/:id',
        name: 'AnalyticsCustomerDetail',
        component: () => import('@/views/analytics/CustomerDetail.vue'),
        meta: {
          requiresAuth: true, title: 'Клиент аналитики', permissions: 'analytics',
        },
      },
    ],
  },

  {
    path: '/reports/coaches_salary/:branch_id/:report_id?',
    name: 'CoachesSalary',
    component: () => import('@/views/report/CoachesSalary.vue'),
    meta: {
      requiresAuth: true, title: 'Отчет ЗП тренеров', permissions: 'reports',
    },
  },


  {
    path: '/reports/personal_training/:branch_id',
    name: 'PersonalTraining',
    component: () => import('@/views/report/PersonalTraining.vue'),
    meta: {
      requiresAuth: true,
      title: 'Отчет Персональные тренировки',
      permissions: 'reports',
    },
  },
  {
    path: '/reports/branch_payments/',
    name: 'BranchPayments',
    component: () => import('@/views/report/BranchPayments.vue'),
    meta: {
      requiresAuth: true, title: 'Отчет Взаиморасчеты между филиалами', permissions: 'reports',
    },
  },
  {
    path: '/reports/court_loading_analytic/:branch_id',
    name: 'CourtLoadingAnalytic',
    component: () => import('@/views/report/CourtLoadingAnalytic.vue'),
    meta: {
      requiresAuth: true,
      title: 'Отчет анализ загрузки кортов/столов',
      permissions: 'reports',
    },
  },
  {
    path: '/reports/services_financial',
    name: 'ServicesFinancialReport',
    component: () => import('@/views/report/ServicesFinancialReport.vue'),
    meta: {
      requiresAuth: true,
      title: 'Финансовый отчет по услугам',
      permissions: 'reports',
    },
  },

  {
    path: '/typography',
    name: 'typography',
    component: () => import('@/views/typography/Typography.vue'),
  },
  {
    path: '/icons',
    name: 'icons',
    component: () => import('@/views/icons/Icons.vue'),
  },
  {
    path: '/cards',
    name: 'cards',
    component: () => import('@/views/cards/Card.vue'),
  },
  {
    path: '/simple-table',
    name: 'simple-table',
    component: () => import('@/views/simple-table/SimpleTable.vue'),
  },
  {
    path: '/form-layouts',
    name: 'form-layouts',
    component: () => import('@/views/form-layouts/FormLayouts.vue'),
  },
  {
    path: '/pages/account-settings',
    name: 'pages-account-settings',
    component: () => import('@/views/pages/account-settings/AccountSettings.vue'),
  },
  {
    path: '/pages/login',
    name: 'pages-login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      title: 'Страница входа',
      guest: true,
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
      title: 'Страница не найдена',
    },
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/Noauth.vue'),
    meta: {
      layout: 'blank',
      title: 'Ошибка, вы не авторизованы',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  await store.dispatch('getAccount')
  const { user } = store.getters

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      if (
        user.permissions.some(p => p.project === to.meta.permissions)
      ) {
        next()
        return
      }
      router.push({
        name: 'Unauthorized',
      })
      return
    }

    next('/pages/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guest)) {
    next()
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    let { title } = to.meta
    if (to.name === 'Льготы' && to.params.section) {
      const bySection = {
        requests: 'Льготы — заявки',
        'user-benefits': 'Льготы — льготы пользователей',
        logs: 'Льготы — логи',
        'new-request': 'Льготы — заявка из ЛК',
      }
      title = bySection[to.params.section] || 'Льготы'
    }
    if (to.name === 'Рейтинг' && to.params.section) {
      const bySection = {
        coaches: 'Рейтинг — авторизованные тренеры',
        criteria: 'Рейтинг — критерии допуска',
      }
      title = bySection[to.params.section] || 'Рейтинг'
    }
    document.title = `${title || DEFAULT_TITLE} – ${DEFAULT_TITLE}`
  })
})

export default router
